import React from 'react';
import '../Modal/modal.css';
import PearsonLogo from '../../../images/pearson_logo.png';


const NoUserDir = ({isOpen, onRequestClose, data}) => {

    const onModalpopupClose = (e) =>{
		onRequestClose(isOpen);
	}

    const openInNewTab = (url) => {
        window.open(url, "_blank", "noreferrer");
     };

    return(
        <div className="modal-content-table" > 

            <table role="presentation" border="0" width="99%" cellSpacing="3" cellPadding="0" >
                <tbody>
                    <tr align="left" valign="top">
                        <td align="left" valign="middle"><span className="pagetitle">&nbsp;No User/Dir Found</span></td>
                        <td align="right" valign="middle"><img src={PearsonLogo} title="Pearson Education" alt="Pearson Education" width="85" height="21" hspace="0" vspace="0" border="0"/></td>
                        <td><span 
                                className="close"
                                role="button"
                                tabIndex={0}
                                onClick={onModalpopupClose}
                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onModalpopupClose(e); } }}
                            >&times;
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div id="table" className='unzip-table'>
                <br/>
                <br/>
                <table role="presentation" border="0" width="99%" cellSpacing="0" cellPadding="0">
                    <tbody>
                        { data?.message?.includes('directory is not in accessiable List') &&
                            <tr align="left" valign="top">
                                <td align="center" valign="middle" className="instructions">
                                You don't have permission to access to the Media Server Console,
                                <button className='no-user-dir-button' onClick={() => openInNewTab("https://pearsonnow.service-now.com/esc?id=sc_cat_item&table=sc_cat_item&sys_id=9336da491b8ea1d01c87ed79b04bcb85&sysparm_role_access=f303af0c1b25f5509c7cbb35464bcb2c")}>please complete this form to request access  
                                    </button>
                                </td>
                            </tr>
                        }
                        { data?.message?.includes("No user found") &&
                            <tr align="left" valign="top">
                                <td align="center" valign="middle" className="instructions">
                                You don't have permission to access this Media Server Console directory,
                                <button className='no-user-dir-button' onClick={() => openInNewTab("https://pearsonnow.service-now.com/esc?id=sc_cat_item&table=sc_cat_item&sys_id=9336da491b8ea1d01c87ed79b04bcb85&sysparm_role_access=f303af0c1b25f5509c7cbb35464bcb2c")}>please complete this form to request access  
                                    </button>
                                </td>
                            </tr>
                        }
                        { data?.message?.includes("Please contact Adminstrator, User is Inactive") &&
                            <tr align="left" valign="top">
                                <td align="center" valign="middle" className="instructions">
                                    {data?.message}
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
                <br/>
                <table role="presentation" width="50%" border="0" cellSpacing="0" cellPadding="0" align="center">
                    <tbody>
                        <tr align="center">
                            <td align="center" valign="middle"><input name="" type="button" className="unzip-formButton" value="&nbsp;Cancel&nbsp;" onClick={onModalpopupClose}/></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );

}

export default NoUserDir